var CarouselRow   = require("app/ui/repeaters/CarouselRow"),
    get           = require("object-path").get,
    kind          = require("enyo/kind"),
    quickMacroize = require("enyo/macroize").quickMacroize;

module.exports = kind(/** @lends  app.SearchPage.PageView.HighlightsCarouselRow.prototype */ {

    /**
     * @private
     */
    name: "app.SearchPage.PageView.HighlightsCarouselRow",

    /**
     * @private
     */
    kind: CarouselRow,

    /**
     * @private
     */
    classes: "app-search-page-page-view-highlights-carousel-row",

    /**
     * @method
     * @private
     */
    initComponents: kind.inherit(function(sup) {
        return function() {
            var $repeater;

            sup.apply(this, arguments);

            $repeater = this.$.repeater;
            $repeater.set("childFormat",     "cover");
            $repeater.set("childFormFactor", "square");
            $repeater.set("childSize",       "md");
            $repeater.set("showTitles",      true);
            $repeater.set("showNewRibbons",  true);
            $repeater.arranger.resetLayoutPlaceholder();
        };
    }),

    /**
     * @private
     */
    observers: {
        update: ["state"]
    },

    /**
     * Update the component in response to state changes.
     *
     * @public
     */
    update: function() {
        var i18nService = this.app.$.i18nService,
            state       = this.state || {},
            query       = get(state, "params.query", null),
            $moreButton = this.$.moreButton,
            $repeater   = this.$.repeater;

        this.$.title.set("content", i18nService.getString("app.SearchPage.HighlightsCarouselRow.Title.caption"));

        $moreButton.show();
        $moreButton.set("href", quickMacroize("/{$language}/search/{$query}", {
            language: i18nService.get("language"),
            query:    encodeURIComponent(query)
        }) + "?" + new  URLSearchParams({
            type: "topic"
        }).toString());
        $moreButton.set("caption", i18nService.getString("app.SearchPage.HighlightsCarouselRow.moreButton.caption"));

        // This will trigger the repeater to re-draw. As such, any changes
        // resulting from either the dataset or the repeater options applied
        // above will be taken care of by the draw cycle.
        $repeater.set("data", get(state, "highlights", []));
    }

});
